export default __webpack_public_path__ + "static/media/paintbrush.7501d99d.JPG";